export var TypePayment;
(function (TypePayment) {
    TypePayment["CONEKTA"] = "CONEKTA";
    TypePayment["CASH"] = "CASH";
    TypePayment["ND"] = "ND";
    TypePayment["STRIPE"] = "STRIPE";
})(TypePayment || (TypePayment = {}));
